export default {"src":"/_next/static/media/emmy-logo-white.1599abd7.svg","height":32,"width":74,"blurWidth":0,"blurHeight":0};